import { render, staticRenderFns } from "./WTelNumberField.vue?vue&type=template&id=c09ea8b0&"
import script from "./WTelNumberField.vue?vue&type=script&lang=js&"
export * from "./WTelNumberField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./WTelNumberField-i18n.yaml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fweb%2Fsrc%2Fcomponents%2Ffields%2FWTelNumberField.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports